import { useAuth0 } from "@auth0/auth0-react";
import Typography from "@material-ui/core/Typography";
import PollIcon from "@material-ui/icons/Poll";
import React from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CostByStagesTable from "./CostByStagesTable";

import { Paper, Popover } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import LibraryIcon from '@material-ui/icons/LocalLibraryOutlined';
import ArrowIcon from '@material-ui/icons/KeyboardBackspace';

import Tooltip from "@material-ui/core/Tooltip";

import RankingChart from "./RankingChart"
import OPKTable from "./OPKTable"
import ProfitTable from "./ProfitTable"

import { apiurl } from '../app/prefs.js';
import TinyChart from "./TinyChart";
import { ReactComponent as XlsIcon } from './xlsx.svg';

import { Dialog, DialogContent } from '@material-ui/core';

import MonthSelect from "./MonthSelection";

import AccountFilter from './AccountFilter.js';
import AccountFilterV2 from './AccountFilter_v2.js';

const VideoIcon = (props) => (
    <svg
        class="svg-icon"
        width='26px'
        height='26px'
        color='#0b6471'
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M725.333333 574.506667l170.666667 113.770666V335.722667l-170.666667 113.770666v125.013334z m0-227.562667l189.653334-126.442667C943.36 201.6 981.333333 221.930667 981.333333 256v512c0 34.069333-37.973333 54.4-66.346666 35.498667L725.333333 677.056v48.106667C725.333333 784.085333 677.504 832 618.752 832H149.248A106.666667 106.666667 0 0 1 42.666667 725.162667V298.837333C42.666667 239.914667 90.496 192 149.248 192h469.504A106.666667 106.666667 0 0 1 725.333333 298.837333v48.106667zM128 298.837333v426.325334A21.333333 21.333333 0 0 0 149.248 746.666667h469.504c11.584 0 21.248-9.685333 21.248-21.504V298.837333A21.333333 21.333333 0 0 0 618.752 277.333333H149.248C137.664 277.333333 128 287.018667 128 298.837333z" fill="#0b6471" /></svg>
)

const PlayIcon = () => (
    <svg width="40px" height="40px" viewBox="-1 0 14 14" id="meteor-icon-kit__solid-play-s" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 1.00154V13.0015C0 13.7788 0.84797 14.259 1.5145 13.859L11.5145 7.859C12.1618 7.4706 12.1618 6.5325 11.5145 6.1441L1.5145 0.14405C0.84797 -0.25586 0 0.22425 0 1.00154z" fill="#758CA3"></path></g></svg>
)

export default function Report039() {
    const [totalData, setTotalData] = React.useState(undefined);
    const [totalDataLoaded, setTotalDataLoaded] = React.useState(false);
    const [drgData, setDrgData] = React.useState(undefined);
    const [patientData, setPatientData] = React.useState(undefined);
    const [drgDataLoaded, setDrglDataLoaded] = React.useState(false);
    const [patientDataLoaded, setPatientDataLoaded] = React.useState(false);
    const [noData, setNoData] = React.useState(false);

    const [selectedYear, setSelectedYear] = React.useState(1);
    const [years, setYears] = React.useState([]);
    const [selectedMonths, setSelectedMonths] = React.useState([]);
    const [reportInfoOpen, setReportInfoOpen] = React.useState(false);

    const { getAccessTokenSilently, user } = useAuth0();

    const [videoListOpen, setVideoListOpen] = React.useState(false);
    const [videoPlayDialogOpen, setVideoPlayDialogOpen] = React.useState(false);
    const [selectedVideo, setSelectedVideo] = React.useState(undefined);

    const [opkFilterItems, setOPKFilterItems] = React.useState([]);
    const [drgFilterItems, setDRGFilterItems] = React.useState([]);
    const [patientFilterItems, setPatientFilterItems] = React.useState([]);

    const [selectedOPK, setSelectedOPK] = React.useState([]);
    const [selectedDRG, setSelectedDRG] = React.useState([]);
    const [selectedPatient, setSelectedPatient] = React.useState([]);
    const [opkFilterStatus, setOPKFilterStatus] = React.useState('None');
    const [opkIdnName, setOpkIdnName] = React.useState('');

    const applyOPKFilter = async (accounts) => {

        const getFilterStatus = () => {
            if (accounts.length === 0) {
                return "None";
            }
            let accountCount = 0;
            const menuData = opkFilterItems;
            for (let c = 0; c < menuData.length; c++) {
                if (menuData[c].children && menuData[c].children.length !== 0) {
                    accountCount = accountCount + menuData[c].children.length;
                } else {
                    accountCount = accountCount + 1;
                }
            }
            if (accountCount === 1) {
                return "One";
            };
            if (accountCount === accounts.length) {
                return "All";
            } else {
                return "Selected";
            }
        };

        setOPKFilterStatus(getFilterStatus());
        setTotalDataLoaded(false);
        loadDataForOPK(accounts);
        setSelectedOPK(accounts);
        setDrglDataLoaded(false);
        setSelectedDRG([]);
        setPatientDataLoaded(false);
        setPatientData(undefined);
        setSelectedPatient([]);
        setPatientFilterItems([]);
        if (accounts.length == 1) setOpkIdnName(getOpkIdnName(accounts[0])); else setOpkIdnName('');

        //settotalDataLoaded(true);
    };

    const applyDRGFilter = async (accounts) => {

        setDrglDataLoaded(false);
        setPatientDataLoaded(false);
        setPatientFilterItems([]);
        setSelectedPatient([]);
        setPatientData(undefined);

        loadDataForDrg(accounts);
        setSelectedDRG(accounts);
        //if (accounts.length == 1) setOpkIdnName(getOpkIdnName(accounts[0])); else setOpkIdnName('');

        //settotalDataLoaded(true);
    };


    const applyPatientFilter = async (patient) => {
        setPatientDataLoaded(false);

        loadDataForPatient(patient);
        setSelectedPatient(patient);
    };

    const handleVideoListClose = () => {
        setVideoListOpen(false)
    };

    const videoData = [
        {
            image: '/manual/reports/00. Raporty w CO+.jpg',
            video: '/manual/reports/00. Raporty w CO+.mp4'
        },
        {
            image: '/manual/reports/Raport - podsumowanie.jpg',
            video: '/manual/reports/Raport - podsumowanie.mp4'
        },
    ];

    const beginnerVideoData = [
        {
            image: '/manual/tutorial/0. Wzorcowy plik MS Excel - wstęp.jpg',
            video: '/manual/tutorial/0. Wzorcowy plik MS Excel - wstęp.mp4',
        },

        {
            video: '/open/3_pierwsze_arkusze.mp4',
            image: '/open/3_pierwsze_arkusze.png',
        },

        {
            image: '/manual/reports/00. Raporty w CO+.jpg',
            video: '/manual/reports/00. Raporty w CO+.mp4'
        },
        {
            image: '/manual/0_Procedury_wstep.jpg',
            video: '/manual/0_Procedury_wstep.mp4',
        },
        {
            image: '/manual/tutorial/Arkusz 1 - Jak dodawać nowe konta zespołu 4.jpg',
            video: '/manual/tutorial/Arkusz 1 - Jak dodawać nowe konta zespołu 4.mp4'
        },
        {
            image: '/manual/procedures/0. Procedury Import danych - wstęp.jpg',
            video: '/manual/procedures/0. Procedury Import danych - wstęp.mp4'
        }
    ];

    const handleVideoSelect = (video) => {
        setSelectedVideo(video);
        setVideoListOpen(false);
        setVideoPlayDialogOpen(true);
    };

    const VideoList = () => {
        return <div>
            {
                videoData.map(
                    (v, i) => {
                        return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
                            <div style={{ position: 'relative' }}>
                                <img src={v.image} alt={'Video nr ' + i} />
                                <div style={{
                                    position: 'absolute',
                                    top: '90px',
                                    left: '190px',
                                    opacity: '.5',
                                    color: 'gray'
                                }}>
                                    <PlayIcon />
                                </div>
                            </div>
                        </div>
                    }
                )
            }
        </div>
    }

    const BeginnersVideoList = () => {
        return <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            {
                beginnerVideoData.map(
                    (v, i) => {
                        return <div className="videoListItem" onClick={() => handleVideoSelect(v)}>
                            <div style={{ position: 'relative' }}>
                                <img src={v.image} alt={'Video nr ' + i} />
                                <div style={{
                                    position: 'absolute',
                                    top: '90px',
                                    left: '190px',
                                    opacity: '.5',
                                    color: 'gray'
                                }}>
                                    <PlayIcon />
                                </div>
                            </div>
                        </div>
                    }
                )
            }
        </div>
    }

    const loadData = (param) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getdrgresults`;
        getAccessTokenSilently().then((token) => {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            };
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {

                    if (fetchedData.error !== undefined) {
                        setNoData(true);
                    } else {
                        //below - code to setup OPK filter during first data load
                        if (param === 'first' && fetchedData.details && Array.isArray(fetchedData.details)) {
                            const dictionary = fetchedData.details.map(
                                parent => {
                                    const children = parent.children.map(
                                        child => ({ id: child.id, name: child.name })
                                    );
                                    return ({
                                        id: parent.parent_id,
                                        name: parent.parent_name,
                                        children: children
                                    })
                                }
                            );
                            const defaultSelected = [];

                            dictionary.forEach(parent => {
                                parent.children.forEach(
                                    child => defaultSelected.push(child.id)
                                )
                            });

                            const drgDictionary = fetchedData.drg_list && fetchedData.drg_list.map(
                                drg => ({ id: drg.DRG, name: drg.DRG })
                            ) || [];

                            setOPKFilterItems(dictionary);
                            setDRGFilterItems(drgDictionary);
                            setSelectedDRG([]);
                            setSelectedOPK(defaultSelected);
                        };

                        setYears(fetchedData.availableYears.map(year => year.YEAR.toString()));
                        setSelectedYear(fetchedData.selectedYear.selectedYear);
                        setTotalData(fetchedData);
                        setTotalDataLoaded(true);
                    };
                });
        });
    };

    const loadDataForOPK = (opkList) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getdrgresults/${selectedYear}/${JSON.stringify(selectedMonths)}`;
        getAccessTokenSilently().then((token) => {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                }
            };
            //console.log(opkFilterItems.length);
            //console.log(opkList.length);
            if (opkFilterItems.reduce((c, p) => c + p.children.length, 0) > opkList.length) {
                Object.assign(
                    requestOptions, {
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(opkList)
                        })
                }
                );
            };
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setTotalData(fetchedData);

                    const drgDictionary = fetchedData.drg_list && fetchedData.drg_list.map(
                        drg => ({ id: drg.DRG, name: drg.DRG })
                    ) || [];

                    setDRGFilterItems(drgDictionary);
                    setSelectedDRG([]);
                    setTotalDataLoaded(true);
                });
        });
    };

    const loadDataForDrg = (opkList) => {
        setDrglDataLoaded(false);
        const apiUrl = `${apiurl}/getdrgresults/${selectedYear}/${JSON.stringify(selectedMonths)}`;
        getAccessTokenSilently().then((token) => {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                }
            };

            const bodyContent = { drgList: JSON.stringify(opkList) };
            if (opkFilterItems.reduce((c, p) => c + p.children.length, 0) > selectedOPK.length) {
                Object.assign(
                    bodyContent,
                    {
                        "opkList": JSON.stringify(selectedOPK)
                    }
                );
            };

            Object.assign(requestOptions, { body: JSON.stringify(bodyContent) });

            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setDrgData(fetchedData.drgData);

                    const patientsDict = fetchedData.patientsList && fetchedData.patientsList.map(
                        patient => ({ id: patient.patient_main_id, name: patient.patient_main_id })
                    ) || [];

                    setPatientFilterItems(patientsDict);
                    setDrglDataLoaded(true);
                });
        });
    };

    const loadDataForPatient = (patientsList) => {
        setPatientDataLoaded(false);
        const apiUrl = `${apiurl}/getdrgresults/${selectedYear}/${JSON.stringify(selectedMonths)}`;
        getAccessTokenSilently().then((token) => {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                }
            };

            const bodyContent = { miList: JSON.stringify(patientsList) };

            Object.assign(requestOptions, { body: JSON.stringify(bodyContent) });

            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setPatientData(fetchedData);
                    setPatientDataLoaded(true);
                });
        });
    };

    const loadDataForYear = (year) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getdrgresults/${year}/${JSON.stringify(selectedMonths)}`;
        getAccessTokenSilently().then((token) => {
            let requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: "Bearer " + token,
                }
            };
            if (opkFilterStatus === 'Selected' || opkFilterStatus === 'One') {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(selectedOPK)
                        })
                }
            }
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setTotalData(fetchedData);
                    setTotalDataLoaded(true);

                });
        });
    };

    const loadDataForMonths = (year, months) => {
        setTotalDataLoaded(false);
        const apiUrl = `${apiurl}/getdrgresults/${year}/${JSON.stringify(months)}`;
        getAccessTokenSilently().then((token) => {
            let requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: "Bearer " + token,
                }
            };
            if (opkFilterStatus === 'Selected' || opkFilterStatus === 'One') {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(selectedOPK)
                        })
                }
            }
            fetch(apiUrl, requestOptions)
                .then((res) => res.json())
                .then((fetchedData) => {
                    setTotalData(fetchedData);
                    setTotalDataLoaded(true);

                });
        });
    };

    const downloadFile = (downloadURL) => {

        getAccessTokenSilently().then((token) => {
            document.body.style.cursor = 'wait';
            const apiUrl = downloadURL;
            let requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    Authorization: "Bearer " + token,
                }
            };
            if (opkFilterStatus === 'Selected' || opkFilterStatus === 'One') {
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(
                        {
                            "opkList": JSON.stringify(selectedOPK)
                        })
                }
            }
            fetch(apiUrl, requestOptions)
                .then((response) => response.blob())
                .then((blob) => {
                    // Create blob link to download
                    const url = window.URL.createObjectURL(
                        new Blob([blob]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        `WynikiOPK.xlsx`,
                    );
                    // Append to html link element page
                    document.body.appendChild(link);
                    // Start download
                    link.click();
                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                    document.body.style.cursor = 'auto';
                });
        });

    };

    const getOpkIdnName = (lookupid) => {
        const opkFilterItems = totalData.details;
        //console.log(lookupid);
        let res = '';
        for (let i = 0; i < opkFilterItems.length; i++) {
            if (opkFilterItems[i].id == lookupid)
                res = opkFilterItems[i].name + ' - ' + opkFilterItems[i].id;
            if (opkFilterItems[i].children)
                opkFilterItems[i].children.forEach((child) => {
                    if (child.id == lookupid) res = child.name + ' - ' + child.id;
                });
        };
        //console.log(res);
        return res;
    };

    React.useEffect(() => {
        let mounted = true;
        loadData('first');
        return function cleanup() {
            mounted = false;
        };
    }, []);

    React.useEffect(() => {
        setSelectedDRG([]);
    }, [selectedOPK]);

    function YearBox() {
        return (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                <Autocomplete
                    id="combo-box"
                    disabled={years.length <= 1}
                    options={years}
                    value={selectedYear}
                    size="small"
                    disableClearable
                    autoHighlight
                    getOptionLabel={(option) => option}
                    getOptionSelected={(option, value) => {
                        if (!value) return false;
                        return option === value;
                    }}
                    style={{ width: "120px", marginBottom: "0px", marginLeft: '0px', marginRight: '10px' }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Rok"
                            variant="filled"
                            InputProps={{
                                ...params.InputProps,
                                disableUnderline: true,
                                style: {
                                    backgroundColor: "#e7f0f1",
                                    color: "#0B6471",
                                    fontSize: "14px",
                                },
                            }}
                        />
                    )}
                    onChange={(event, value) => {
                        if (value) {
                            setSelectedYear(value);
                            loadDataForYear(value);
                        }
                    }}
                />
            </div>
        );
    }



    return (
        <div className="App" style={{ position: "relative" }}>
            <div
                style={{
                    //background: "linear-gradient(to right, #0b6471, #9BC0C5)",
                    display: "flex",
                    height: "55px",
                    width: "100%",
                    backgroundColor: "#0b6471",
                    color: "white",
                    borderRadius: "5px",
                    paddingTop: "0px",
                    paddingLeft: "0px",
                    alignItems: "center",
                }}
            >
                <div style={{ width: "80px", marginTop: "5px" }}>
                    <PollIcon
                        style={{
                            marginLeft: "20px",
                            marginRight: "20px",
                            fontSize: "42px",
                        }}
                    />
                </div>
                <div>
                    <Typography variant="h5" style={{ color: "white" }}>
                        Wyniki JGP / Pacjentów
                    </Typography>
                </div>
            </div>

            {totalData ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        transition: "opacity 0.5s",
                        opacity: totalDataLoaded ? "1" : "0.2",
                        paddingTop: '5px',
                    }}
                >
                    <div
                        style={{
                            display: "flex", justifyContent: "flex-start", backgroundColor: 'white', padding: '5px', borderRadius: '5px', padding: '5px', marginBottom: '5px', marginRight: '1px'
                        }}
                    >
                        <YearBox />
                        <div style={{ marginRight: '10px', backgroundColor: '#e7f0f1', borderRadius: '5px', padding: '5px 0px 0px 5px' }}>
                            <MonthSelect
                                version={2}
                                setSelectedMonthsFunction={setSelectedMonths}
                                loadDataFunction={loadDataForMonths}
                                selectedMonthsProperty={selectedMonths}
                                startDateProperty={{ year: selectedYear }}
                            />
                        </div>
                        <div style={{ marginRight: '10px', backgroundColor: '#e7f0f1', borderRadius: '5px', padding: '5px 0px 0px 5px' }}>
                            <AccountFilter
                                titleCaption="OPK"
                                underLine={true} //disable underline
                                fontSize='14px'
                                fontStyle='italic'
                                fontColor='rgb(11, 100, 113)'
                                marginTop='-3px'
                                menuData={opkFilterItems}
                                startSelection={selectedOPK}
                                updateFunction={applyOPKFilter}
                            />
                        </div>
                        <div style={{ display: 'none' }}>
                            <Tooltip title='Opis raportu'>
                                <Button
                                    id='reportInfoIcon'
                                    onClick={() => setReportInfoOpen(true)}
                                    style={{
                                        marginTop: "0px",
                                        width: "48px",
                                        minWidth: "48px",
                                        height: "46px",
                                        backgroundColor: "#e7f0f1",
                                        color: "#0B6471",
                                        borderRadius: "5px",
                                        marginRight: '10px',
                                    }}
                                >
                                    <LibraryIcon
                                        style={{ width: "30px", height: "30px" }}
                                    />
                                </Button>
                            </Tooltip>
                        </div>


                        <Tooltip title='Pobierz raport jako XLS'>
                            <Button
                                id='saveXLS'
                                disabled={opkFilterStatus == 'None'}
                                onClick={
                                    () => downloadFile(`${apiurl}/getdrgresults/${selectedYear}/${JSON.stringify(selectedMonths)}/xls`)
                                }
                                style={{
                                    marginTop: "0px",
                                    width: "48px",
                                    minWidth: "48px",
                                    height: "46px",
                                    backgroundColor: "#e7f0f1",
                                    color: "#0B6471",
                                    borderRadius: "5px",
                                    marginRight: '10px',
                                }}
                            >
                                <XlsIcon
                                    style={{ marginTop: '0px', cursor: 'pointer', fill: '#0B6471', height: '22px' }}
                                />
                            </Button>
                        </Tooltip>

                        <div style={{ display: 'none' }}>
                            <Tooltip title='Instrukcje video'>
                                <Button
                                    id='video'
                                    onClick={
                                        () => setVideoListOpen(true)
                                    }
                                    style={{
                                        marginTop: "0px",
                                        width: "48px",
                                        minWidth: "48px",
                                        height: "46px",
                                        backgroundColor: "#e7f0f1",
                                        color: "#0B6471",
                                        borderRadius: "5px",
                                        marginRight: '10px',
                                    }}
                                > <sup style={{ position: 'absolute', color: '#FE8E3C', fontWeight: 'bold', top: '0px', left: '4px' }}>N</sup>
                                    <VideoIcon
                                        style={{ color: '#0B6471', marginTop: '2px', cursor: 'pointer' }}
                                    />
                                </Button>
                            </Tooltip>
                        </div>

                    </div>


                    {totalData.drg_summary_top && totalData.drg_summary_top.length != 0 ?
                        <div>
                            <div style={{ border: "solid 1px #4E97A5", borderRadius: '5px', padding: '5px', backgroundColor: 'white' }}>
                                <div style={{ fontSize: '18px', fontWeight: '500', color: "#0B6471", marginTop: '5px', marginBottom: '5px' }}> Ranking </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        flexWrap: "nowrap",
                                        overflow: "auto",
                                        transition: "opacity 0.5s",
                                        opacity: totalDataLoaded ? "1" : "0.2",
                                    }}
                                >

                                    <CostByStagesTable
                                        marginRight='5px'
                                        title={<div style={{ fontSize: '16px', fontWeight: '500' }}>Najbardziej rentowne JGP</div>}
                                        dimUnexpanded='true'
                                        data={totalData.drg_summary_top}
                                        maximumFractionDigits='0'
                                        columns={
                                            [
                                                { name: 'JGP', value: 'DRG', align: 'left', type: 'text', underline: '1px solid' },
                                                { name: 'OPK', value: 'opk_name', align: 'left', type: 'text', underline: '1px solid' },
                                                { name: <div><div style={{ fontWeight: "400" }}>Ilość</div></div>, value: 'qty', align: 'right', type: 'text', underline: '2px single' },
                                                { name: <div><div style={{ fontWeight: "400" }}>Wynik średni</div></div>, value: 'result_avg', align: 'right', type: 'text', underline: '5px double' },
                                                { name: <div><div style={{ fontWeight: "400" }}>Wynik ogółem</div></div>, value: 'result_sum', align: 'right', type: 'text', underline: '5px double' },

                                            ]
                                        }
                                    />


                                    <CostByStagesTable
                                        title={<div style={{ fontSize: '16px', fontWeight: '500' }}>Najmnniej rentowne JGP</div>}
                                        dimUnexpanded='true'
                                        data={totalData.drg_summary_bottom}
                                        maximumFractionDigits='0'
                                        columns={
                                            [
                                                { name: 'JGP', value: 'DRG', align: 'left', type: 'text', underline: '1px solid' },
                                                { name: 'OPK', value: 'opk_name', align: 'left', type: 'text', underline: '1px solid' },
                                                { name: <div><div style={{ fontWeight: "400" }}>Ilość</div></div>, value: 'qty', align: 'right', type: 'text', underline: '2px single' },
                                                { name: <div><div style={{ fontWeight: "400" }}>Wynik średni</div></div>, value: 'result_avg', align: 'right', type: 'text', underline: '5px double' },
                                                { name: <div><div style={{ fontWeight: "400" }}>Wynik ogółem</div></div>, value: 'result_sum', align: 'right', type: 'text', underline: '5px double' },

                                            ]
                                        }
                                    />
                                </div>
                            </div>

                            <div style={{ border: "solid 1px #4E97A5", borderRadius: '5px', padding: '5px', backgroundColor: 'white', marginTop: '5px' }}>
                                <div style={{ fontSize: '18px', fontWeight: '500', color: "#0B6471", marginTop: '5px', marginBottom: '5px' }}> JGP </div>
                                <div style={{ marginRight: '10px', backgroundColor: '#e7f0f1', borderRadius: '5px', padding: '5px 0px 0px 5px', width: 'fit-content' }}>
                                    <AccountFilterV2
                                        titleCaption="JGP"
                                        underLine={true} //disable underline
                                        hideSelectAllOption={true}
                                        fontSize='14px'
                                        fontStyle='italic'
                                        fontColor='rgb(11, 100, 113)'
                                        marginTop='-3px'
                                        menuData={drgFilterItems}
                                        startSelection={selectedDRG}
                                        updateFunction={setSelectedDRG}
                                        applyChangesFunction={applyDRGFilter}
                                    />
                                </div>
                                {drgDataLoaded &&
                                    <div>
                                        <CostByStagesTable
                                            title=' '
                                            dimUnexpanded='true'
                                            data={drgData}
                                            columns={
                                                [
                                                    { name: 'JPG', value: 'product', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Oddział', value: 'division', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: <div style={{ fontWeight: "400" }}>Ilość</div>, value: 'qty', chartValue: 'qtyMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                                                    { name: <div style={{ fontWeight: "400" }}>Koszt (średnia)</div>, value: 'costAvg', chartValue: 'costAvgMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                                                    { name: <div style={{ fontWeight: "400" }}>Koszt (suma)</div>, value: 'costTotal', chartValue: 'costTotalMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                                                    { name: <div style={{ fontWeight: "400" }}>Wynik (średnia)</div>, value: 'incomeAvg', chartValue: 'incomeAvgMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                                                    { name: <div style={{ fontWeight: "400" }}>Wynik (suma)</div>, value: 'incomeTotal', chartValue: 'incomeTotalMonthly', align: 'right', type: 'mixed', underline: '2px solid' },
                                                ]
                                            }
                                        />
                                    </div>
                                }
                            </div>

                            {/* PATIENT DATA */}
                            {drgDataLoaded && <div style={{ border: "solid 1px #4E97A5", borderRadius: '5px', padding: '5px', backgroundColor: 'white', marginTop: '5px' }}>
                                <div style={{ fontSize: '18px', fontWeight: '500', color: "#0B6471", marginTop: '5px', marginBottom: '5px' }}> Pacjent </div>
                                <div style={{ marginRight: '10px', backgroundColor: '#e7f0f1', borderRadius: '5px', padding: '5px 0px 0px 5px', width: 'fit-content' }}>
                                    <AccountFilterV2
                                        titleCaption="Pacjent"
                                        underLine={true} //disable underline
                                        hideSelectAllOption={true}
                                        fontSize='14px'
                                        fontStyle='italic'
                                        fontColor='rgb(11, 100, 113)'
                                        marginTop='-3px'
                                        menuData={patientFilterItems}
                                        startSelection={selectedPatient}
                                        updateFunction={setSelectedPatient}
                                        applyChangesFunction={applyPatientFilter}
                                    />
                                </div>
                                {patientDataLoaded &&
                                    <div>
                                        <br />

                                        <div style={{border: "1px solid #4E97A5", borderRadius: "7px", padding: '10px', margin: '5px' }}>
                                            <p style={{ fontSize: '16px' }}>Numer główny: <strong>{patientData.main_id}</strong></p>
                                            <p style={{ fontSize: '16px' }}>JGP: <strong>{patientData.drg}</strong> </p>
                                            <br />
                                            <p style={{ fontSize: '15px' }}>Przychód: <strong>{patientData.income.toLocaleString("pl-PL", { maximumFractionDigits: 0, })}</strong></p>
                                            <p style={{ fontSize: '15px' }}>Koszt ogółem: <strong>{(patientData.procedure_cost + patientData.hd_cost + patientData.direct_cost).toLocaleString("pl-PL", { maximumFractionDigits: 2, })}</strong></p>
                                            <p style={{ fontSize: '15px' }}>Koszt procedur: <strong>{patientData.procedure_cost.toLocaleString("pl-PL", { maximumFractionDigits: 2, })}</strong></p>
                                            <p style={{ fontSize: '15px' }}>Koszt osobodni: <strong>{patientData.hd_cost.toLocaleString("pl-PL", { maximumFractionDigits: 2, })}</strong> Liczba osobodni: <strong>{patientData.hd_qty.toLocaleString("pl-PL", { maximumFractionDigits: 0, })}</strong> </p>
                                            <p style={{ fontSize: '15px' }}>Koszt leków i materiałów: <strong>{patientData.direct_cost.toLocaleString("pl-PL", { maximumFractionDigits: 2, })}</strong></p>
                                        </div>

                                        <CostByStagesTable
                                            title={<div style={{ fontWeight: 'bold' }}>Procedury</div>}
                                            dimUnexpanded='true'
                                            data={patientData.procedure_cost_details}
                                            columns={
                                                [
                                                    { name: 'Procedura', value: 'procedure_name', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'OPK Proceduralny', value: 'source_opk_name', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Oddział', value: 'opk_name', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Ilość', value: 'driver_value', align: 'right', type: 'text', underline: '2px solid' },
                                                    { name: 'Koszt', value: 'procedure_cost', align: 'right', type: 'text', underline: '2px solid' },
                                                ]
                                            }
                                        />

                                        <CostByStagesTable
                                            title={<div style={{ fontWeight: 'bold' }}>Osobodni</div>}
                                            dimUnexpanded='true'
                                            data={patientData.hd_details}
                                            columns={
                                                [
                                                    { name: 'Oddział', value: 'opk_name', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Numer oddziałowy', value: 'ward_id', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Miesiąc', value: 'month', align: 'right', type: 'text', underline: '1px solid' },
                                                    { name: 'Dni', value: 'hd_qty', align: 'right', type: 'text', underline: '2px solid' },
                                                    { name: 'Koszt', value: 'hd_cost', align: 'right', type: 'text', underline: '2px solid' },
                                                ]
                                            }
                                        />

                                        <CostByStagesTable
                                            title={<div style={{ fontWeight: 'bold' }}>Leki i materiały</div>}
                                            dimUnexpanded='true'
                                            data={patientData.direct_cost_details}
                                            columns={
                                                [
                                                    { name: 'Oddział', value: 'opk_name', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Numer oddziałowy', value: 'ward_id', align: 'left', type: 'text', underline: '1px solid' },
                                                    { name: 'Miesiąc', value: 'month', align: 'right', type: 'text', underline: '1px solid' },
                                                    { name: 'Koszt', value: 'direct_cost', align: 'right', type: 'text', underline: '2px solid' },
                                                ]
                                            }
                                        />

                                    </div>
                                }
                            </div>
                            }

                        </div>

                        : selectedOPK.length === 0 && <Typography style={{ position: "absolute", top: "150%", left: "45%", color: "#0b6471", textJustify: "left" }} variant="h5">Wybierz OPK</Typography>}
                    {!totalDataLoaded && <CircularProgress style={{ position: "absolute", height: "70px", width: "70px", top: totalData.yearlydata ? "50%" : "120%", left: "50%", color: "#0b6471", opacity: "0.6" }} />}





                    <Popover
                        id='hintPopOver'
                        open={reportInfoOpen}
                        anchorEl={document.getElementById('reportInfoIcon')}
                        onClose={() => setReportInfoOpen(false)}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center"
                        }}
                    >
                        <Paper
                            style={{
                                padding: "10px",
                                width: "600px",
                                fontFamily: "roboto",
                                display: "flex",
                                flexDirection: "column"
                            }}
                        >
                            <div
                                style={{
                                    top: "0px",
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "right"
                                }}
                            >
                                <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => setReportInfoOpen(false)} />
                            </div>
                            <div style={{ fontSize: '16px', padding: '5px', marginBottom: '5px' }}>
                                <p>Raport zawiera <b>wyniki, przychody oraz koszty całkowite</b> (suma kosztów bezpośrednich i doliczonych)
                                    dla poszczególnych komórek (Ośrodków Powstawania Kosztów).</p>
                                <p>Raport nie pokazuje kosztów poszczególnych komórek pomocniczych i proceduralnych, ponieważ
                                    zgodnie z wymogami Standardu Rachunku Kosztów, zostały one rozliczone na inne komórki widoczne
                                    w raporcie. Analiza kosztów utrzymania tych komórek dostępna jest w raportach: <b>OPK Pomocnicze</b> oraz <b>OPK Proceduralne</b>.</p>
                            </div>
                            <div
                                style={{
                                    top: "60px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    borderTop: '1px #0B6471 solid'
                                }}
                            >
                                <Button onClick={() => setReportInfoOpen(false)}>
                                    Zakończ
                                </Button>
                            </div>
                        </Paper>
                    </Popover>
                </div>
            ) : (
                (!totalData && !noData) && (
                    <Typography
                        style={{
                            position: "absolute",
                            top: "120%",
                            left: "40%",
                            color: "#0b6471",
                            textJustify: "left",
                        }}
                        variant="h5"
                    >
                        Wczytywanie danych
                    </Typography>
                )
            )}
            {(!totalDataLoaded && !noData && false) && (
                <CircularProgress
                    style={{
                        position: "absolute",
                        height: "70px",
                        width: "70px",
                        top: totalData ? "50%" : "120%",
                        left: "50%",
                        color: "#0b6471",
                        opacity: "0.6",
                    }}
                />
            )}
            {(noData) && (
                <div>
                    <Typography
                        style={{
                            color: "#0b6471",
                            textJustify: "center",
                            marginTop: '10px',
                            marginBottom: '20px',
                        }}
                        variant="h5"
                    >
                        Do aplikacji nie zaimportowano jeszcze żadnych danych.
                    </Typography>
                    <div>
                        <BeginnersVideoList />
                    </div>
                </div>
            )}

            <Popover
                id='videoSelectPopOver'
                open={totalDataLoaded && videoListOpen}
                anchorEl={document.getElementById('video')}
                onClose={handleVideoListClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
            >
                <Paper
                    style={{
                        padding: "10px",
                        width: "450px",
                        fontFamily: "roboto",
                        display: "flex",
                        flexDirection: "column",
                        //height: 'calc(100vh - 270px)'
                    }}
                >

                    <div
                        style={{
                            top: "0px",
                            display: "flex",
                            width: "100%",
                            justifyContent: "right"
                        }}
                    >

                        <CloseIcon style={{ cursor: 'pointer', fontSize: '16px' }} onClick={() => handleVideoListClose()} />

                    </div>

                    <VideoList />

                </Paper>
            </Popover>
            <Dialog

                maxWidth='90vw'
                open={videoPlayDialogOpen}
                onClose={() => setVideoPlayDialogOpen(false)}
                aria-labelledby="dialog-title"
                aria-describedby="dialog-description"

            >
                <DialogContent style={{ display: 'flex', flexDirection: 'column', margin: '0px', padding: '0px' }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '3px 10px 3px 0px' }}>
                        <button
                            onClick={() => {
                                const div = document.getElementById('videoControl');
                                if (div.requestFullscreen)
                                    div.requestFullscreen();
                                else if (div.webkitRequestFullscreen)
                                    div.webkitRequestFullscreen();
                                else if (div.msRequestFullScreen)
                                    div.msRequestFullScreen();
                            }
                            }
                            style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                        >
                            Pełen ekran
                        </button>
                        <button
                            onClick={() => setVideoPlayDialogOpen(false)}
                            style={{ backgroundColor: 'white', color: '#0b6471', fontWeight: 'bold', textDecorationLine: 'underline' }}
                        >
                            Zamknij
                        </button>
                    </div>
                    <video id='videoControl' controls autoPlay style={{ width: '80vw' }}>
                        <source src={selectedVideo && selectedVideo.video} type="video/mp4" />
                        Video control not supported by browser
                    </video>

                </DialogContent>
            </Dialog>
        </div>

    );
}
